import React from 'react';
import TitleHeader from '../../global/TitleHeader'; // adjust path based on your file structure
import Value from './Value';
import NewsLetter from "../home/NewsLetter";
import About from './About';

const AboutIndex = () => {
  return (
    <div>
      <TitleHeader
        title="About Us"
        description="Innovative thermocol packaging solutions designed to protect, preserve, and perform."
      />
      <About/>
      <Value/>
      <NewsLetter />
    </div>
  );
};

export default AboutIndex;
